import { render, staticRenderFns } from "./updSingleHsnp.vue?vue&type=template&id=ac0a1bae&scoped=true"
import script from "./updSingleHsnp.vue?vue&type=script&lang=js"
export * from "./updSingleHsnp.vue?vue&type=script&lang=js"
import style0 from "./updSingleHsnp.vue?vue&type=style&index=0&id=ac0a1bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0a1bae",
  null
  
)

export default component.exports